import { HttpClient } from '../HttpClient';
/**
 * * Get Salary History Details
 */

export const GetSalaryHistoryDetails = async ({ systemId, ExcludePending }) => {
  try {
    const { data } = await HttpClient.get(`/api/employees/${systemId}/SalaryHistory`, {
      params: {
        ExcludePending,
      },
    });

    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
